import { faRotateRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { B2Button, B2Card } from "@hdb/biome-2";
import { useQuery } from "@tanstack/react-query";
import * as _ from "lodash";
import { createRef, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import * as yup from "yup";
import { getGatewayGroup } from "../../../../../../core/api/services/asset/gateway-group.service";
import { getRainProfile } from "../../../../../../core/api/services/asset/light-profile/rain-profile.service";
import { getOperationMode } from "../../../../../../core/api/services/asset/light-profile/timer-profile.service";
import MfaComponent from "../../../../../../core/components/mfa/mfa.component";
import ModalComponent from "../../../../../../core/components/modal/modal.component";
import { AssetCommandEnums } from "../../../../../../core/enums/assetCommands-enums";
import HasPermission from "../../../../../../core/guards/has-permission";
import {
  convertTo24Hour,
  removeSecondsFromTime,
} from "../../../../../../shared/helpers/convert-time-format";
import { safeAtob } from "../../../../../../shared/helpers/enode-decode-string";
import capitalizeFirst from "../../../../../../shared/helpers/upper-case";
import TitleComponent from "../../../../../../shared/title/title.component";
import {
  enableOrDisableRainProfile,
  getAssetsByGateway,
  getDaysOfWeek,
  postRainProfile,
  sendGetCommandToDms,
} from "../../../../../../store/slices/asset.slice";
import { setOtpIsValidation } from "../../../../../../store/slices/mfa-otp.slice";
import AssetActionFormComponent from "../common/asset-action-form.component";
import { Helmet } from "react-helmet-async";
import { getUserInfo } from "src/core/auth/auth.service";
import { displayToast } from "src/shared/helpers/toaster.helper";

const RainProfileComponent = () => {
  const dispatch = useDispatch();
  const params: any = useParams();
  const id = params.id ? safeAtob(params.id) : null;
  const formRef = createRef();
  const user = getUserInfo();

  const mfaInfo = useSelector((state: any) => {
    return state.user.mfaInfo;
  });

  const [PageNumber, setPageNum] = useState<number>(1);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isDetails, setIsDetails] = useState<boolean>(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [SortBy, setSortBy] = useState<any>(capitalizeFirst("profileName"));
  const [SortDirection, setSortDirection] = useState<any>("desc");
  const [searchValue, setSearchValue] = useState("");
  const pageSize = 10;
  const [submittedFormData, setSubmittedFormData] = useState<any>({});
  const [actionOptions, setActionOptions] = useState([]);
  const [groupOptions, setGroupOptions] = useState<any>([]);
  const [isRefreshing, setIsRefreshing] = useState<boolean>(false);

  const [initialValues, setInitialValues] = useState<any>({
    profileName: "",
    startTime: "",
    endTime: "",
    repeatAction: 0,
    rainsensor: "",
    zoneID: "",
    lightRainThreshold: "",
    heavyRainThreshold: "",
    lightRainActionId: "",
    heavyRainActionId: "",
    isEnabled: false,
  });

  // const connectSocket = () => {
  //   const rainProfileClient = new W3CWebSocket(
  //     `${process.env.REACT_APP_WS_BASE_URL}/slpapp/push?name=asset-rainprofile`
  //   );

  //   rainProfileClient.onopen = () => {
  //     console.log("WebSocket Rain Profile Client Connected");

  //     setSocketStatus("open");
  //     rainProfileClient.send(
  //       JSON.stringify({ token: new Date().getUTCMilliseconds() })
  //     );
  //     setRetryCount(0);
  //   };

  //   rainProfileClient.onmessage = (message) => {
  //     const data = JSON.parse(`${message.data}`);
  //     const user = getUserInfo();
  //     if (
  //       user.email.toLowerCase() === data.NotificationIdentifier.toLowerCase()
  //     ) {
  //       toast.success("Acknowledgement Received", {
  //         position: "top-right",
  //         autoClose: 3000,
  //         hideProgressBar: false,
  //         closeOnClick: false,
  //         pauseOnFocusLoss: true,
  //         draggable: true,
  //         pauseOnHover: true,
  //       });
  //     }

  //     refetchRainProfile();
  //   };

  //   rainProfileClient.onclose = (event) => {
  //     console.log("WebSocket Rain Profile Closed", event);

  //     setSocketStatus("closed");
  //     setIsCallRetry((prev: boolean) => !prev);
  //   };

  //   setSocket(rainProfileClient);
  // };

  // useEffect(() => {
  //   setRetryCount((current: number) => current + 1);

  //   if (socketStatus == "initial") {
  //     connectSocket();
  //   } else if (socketStatus == "closed") {
  //     if (retryCount < WEBSOCKET_MAX_RETRY_COUNT) {
  //       setTimeout(() => {
  //         console.log(
  //           `Rain Profile Retry Attempts ${retryCount}/${WEBSOCKET_MAX_RETRY_COUNT}}`
  //         );

  //         connectSocket();
  //       }, 5000);
  //     } else {
  //       console.log(
  //         `Maximum retry attempts reached for Rain Profile WebSocket`
  //       );
  //     }
  //   }

  //   return () => {
  //     if (socket && socket.readyState === socket.OPEN) {
  //       socket.close();
  //       console.log("Rain Profile Client socket closed");
  //     }
  //   };
  // }, [socketStatus, isCallRetry]);

  const socketRealTimeUpdate = useSelector((state: any) => {
    return state.asset.socketRealTimeUpdate;
  });

  const socketRealTimeUpdateData = useSelector((state: any) => {
    return state.asset.socketRealTimeUpdateData;
  });

  const socketData = useSelector((state: any) => {
    return state.asset.socketData;
  });

  const {
    data: rainProfiles,
    refetch: refetchRainProfile,
    isFetching,
  } = useQuery({
    queryKey: [
      "getRainProfile",
      pageSize,
      PageNumber,
      SortBy,
      SortDirection,
      id,
      searchValue,
    ],
    queryFn: () =>
      getRainProfile(
        pageSize,
        PageNumber,
        SortBy,
        SortDirection,
        id,
        searchValue
      ),
    // enabled: onRefetchEnabled
  });

  const showToaster = (socketRealTimeUpdateData: any) => {
    if (
      user[
      "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
      ] === socketData?.NotificationIdentifier
    ) {
      displayToast(
        socketRealTimeUpdateData?.PushMessage || "Acknowledgement Received",
        socketRealTimeUpdateData?.ToasterColor
      );
    }
  };

  useEffect(() => {
    const copiedSocketRealTimeUpdate = _.cloneDeep(socketRealTimeUpdate);

    if (copiedSocketRealTimeUpdate.RainProfile) {
      showToaster(socketRealTimeUpdateData);
      refetchRainProfile();
      // setOnRefetchEnabled(true);
    }
  }, [socketRealTimeUpdate]); // socketRealTimeUpdateData

  const { data: operationModes } = useQuery({
    queryKey: ["getOperationMode"],
    queryFn: () => getOperationMode(),
  });

  useEffect(() => {
    const modes = operationModes?.data?.map((mode: any) => ({
      value: mode?.id,
      label: mode?.name,
    }));

    setActionOptions(modes);
  }, [operationModes]);

  const { data: gatewayGroups } = useQuery({
    queryKey: ["getGatewayGroup", id],
    queryFn: () => getGatewayGroup(id!),
  });

  useEffect(() => {
    const groups = gatewayGroups?.data?.map((group: any) => ({
      value: group?.zoneId,
      label: group?.groupName + ` (Zone - ${group?.zoneId})`,
    }));

    setGroupOptions(groups);
  }, [gatewayGroups]);

  useEffect(() => {
    if (!rainProfiles || !Object.keys(rainProfiles).length) return;

    setInitialValues({
      profileName: rainProfiles?.profileName,
      startTime: removeSecondsFromTime(rainProfiles?.startTime),
      endTime: removeSecondsFromTime(rainProfiles?.endTime),
      rainsensor: rainProfiles?.rainsensor,
      zoneID: rainProfiles?.zoneID,
      lightRainThreshold: rainProfiles?.lightRainThreshold,
      heavyRainThreshold: rainProfiles?.heavyRainThreshold,
      lightRainActionId: rainProfiles?.lightRainActionId,
      heavyRainActionId: rainProfiles?.heavyRainActionId,
      isEnabled: rainProfiles?.isEnabled,
      repeatAction: rainProfiles?.repeatAction || 0,
    });
  }, [rainProfiles]);

  useEffect(() => {
    dispatch({
      type: "table/toggleSelectAll",
      payload: [],
    });

    dispatch(getDaysOfWeek());
  }, [dispatch]);

  const formConfig = {
    controls: [
      {
        label: "Daylight Profile",
        isGrid: true,
        isShadow: false,
        gridClass: "profile-grid",
        controlGroup: [
          {
            name: "startTime",
            label: "Start Time",
            placeholder: "",
            type: "time",
            required: true,
            readOnly: isDetails,
            disabled: isDetails,
          },
          {
            name: "endTime",
            label: "End Time",
            placeholder: "",
            type: "time",
            required: true,
            readOnly: isDetails,
            disabled: isDetails,
          },
          {
            name: "lightRainThreshold",
            label: "Light Rain Threshold (%)",
            placeholder: "e.g: 5",
            type: "number",
            required: true,
            readOnly: isDetails,
            disabled: isDetails,
          },
          {
            name: "lightRainActionId",
            label: "Light Rain Action",
            placeholder: "Select Light Rain Action",
            type: "select",
            options: actionOptions,
            required: true,
            readOnly: isDetails,
            disabled: isDetails,
          },
          {
            name: "heavyRainThreshold",
            label: "Heavy Rain Threshold (%)",
            placeholder: "e.g: 30",
            type: "number",
            required: true,
            readOnly: isDetails,
            disabled: isDetails,
          },
          {
            name: "heavyRainActionId",
            label: "Heavy Rain Action",
            placeholder: "Select Heavy Rain Action",
            type: "select",
            options: actionOptions,
            required: true,
            readOnly: isDetails,
            disabled: isDetails,
          },
          {
            name: "zoneID",
            label: "Group",
            placeholder: "Select Group",
            type: "select",
            options: groupOptions,
            required: true,
            readOnly: isDetails,
            disabled: isDetails,
          },
          {
            name: "repeatAction",
            label: "Repeat Action",
            placeholder: "e.g: 30",
            type: "number",
            readOnly: isDetails,
            disabled: isDetails,
          },
          {
            name: "rainsensor",
            label: "Rain Sensor",
            placeholder: "Search Rain Sensor",
            type: "chips",
            dispatchableApi: getAssetsByGateway,
            readOnly: isDetails,
            disabled: isDetails,
            gridFullWidth: true,
          },
          {
            name: "isEnabled",
            label: "Profile Control",
            placeholder: "",
            type: "switch",
            required: true,
            readOnly: isDetails,
            disabled: isDetails,
          },
        ],
      },
    ],
  };

  const validation = yup.object().shape({
    startTime: yup.string().required("Start Time is required"),
    endTime: yup.string().required("End Time is required"),
    zoneID: yup.string().required("Zone is required"),
    repeatAction: yup.number().min(0, "Should be a positive number"),
    lightRainThreshold: yup
      .string()
      .required("Light Rain Threshold is required"),
    heavyRainThreshold: yup
      .string()
      .required("Heavy Rain Threshold is required"),
    lightRainActionId: yup.string().required("Light Rain ActionId is required"),
    heavyRainActionId: yup.string().required("Heavy Rain ActionId is required"),
  });

  const handleCloseModal = () => {
    setIsEdit(false);
    setIsDetails(false);
    setIsDelete(false);
  };

  const onSubmit = () => {
    const form: any = formRef.current;

    if (form) {
      form.handleSubmit();

      const {
        startTime,
        endTime,
        zoneID,
        repeatAction,
        lightRainThreshold,
        heavyRainThreshold,
        lightRainActionId,
        heavyRainActionId,
        isEnabled,
      } = form.values;

      if (
        !startTime ||
        !endTime ||
        !zoneID ||
        !lightRainThreshold ||
        !heavyRainThreshold ||
        !lightRainActionId ||
        !heavyRainActionId ||
        repeatAction < 0
      ) {
        return;
      }

      // setIsOtpModalOpen(true);

      const data = {
        ...form.values,
        startTime: convertTo24Hour(form.values.startTime),
        endTime: convertTo24Hour(form.values.endTime),
        heavyRainActionId: Number.parseInt(form.values.heavyRainActionId),
        lightRainActionId: Number.parseInt(form.values.lightRainActionId),
        rainsensor: form.values.rainsensor,
        isEnabled: Boolean(form.values.isEnabled),
        assetCode: id,
        profileControl: "",
      };

      setInitialValues(data);
      setSubmittedFormData(data);

      if (mfaInfo?.isDMSMfaEnabled) {
        setIsOtpModalOpen(true);
      } else {
        onSubmitMfaOtp(data);
      }
    }

    handleCloseModal();
  };

  const onSubmitMfaOtp = (data?: any) => {
    dispatch(postRainProfile({ body: data ? data : submittedFormData })).then(
      (res: any) => {
        dispatch(enableOrDisableRainProfile({ id: res?.payload?.data?.id }));

        refetchRainProfile();
      }
    );

    handleCloseOtpModal();
    dispatch(setOtpIsValidation(false));
  };

  const [isOTPModalOpen, setIsOtpModalOpen] = useState<boolean>(false);

  const isOtpVerified = useSelector((state: any) => {
    return state.otp.isOtpVerified;
  });

  const handleCloseOtpModal = () => {
    setIsOtpModalOpen(false);
  };

  const mfaActionConfig: any = [
    {
      label: "Save",
      event: onSubmitMfaOtp,
      variant: "primary",
      disabled: !isOtpVerified,
    },
  ];

  const handleRefresh = () => {
    setIsRefreshing(true);

    dispatch(
      sendGetCommandToDms({
        assetCode: id,
        module: Number(AssetCommandEnums.RainProfile),
      })
    )
      .then(() => {
        refetchRainProfile()
          .then(() => {
            setIsRefreshing(false);
          })
          .catch(() => {
            setIsRefreshing(false);
          });
      })
      .catch(() => {
        setIsRefreshing(false);
      });
  };

  return (
    <>
      <Helmet>
        <title>Rain Profile | Asset</title>
      </Helmet>
      <div>
        <div>
          <div className="my-5">
            <TitleComponent title="Configure Rain Profile" />
          </div>

          <div className="my-3">
            <B2Card className="card-bg">
              <B2Card.Header className="fs-5 fw-bold header-bg">
                <div className="d-flex form-header dashboard-generic-actions align-items-center">
                  <p className="m-0 flex-grow-1">Profile Information</p>
                  <button
                    type="button"
                    className="ms-2 cursor-pointer fs-6 fw-bold"
                    onClick={handleRefresh}
                    style={{
                      padding: "0",
                      background: "none",
                      border: "none",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faRotateRight}
                      className="fs-7 me-2"
                    />
                    Refresh
                  </button>
                </div>
              </B2Card.Header>

              <B2Card.Body>
                {isRefreshing || isFetching ? (
                  <div
                    className="d-flex justify-content-center"
                    style={{ minHeight: "400px" }}
                  >
                    <Spinner
                      animation="border"
                      variant="primary"
                      className="mt-5"
                    />
                  </div>
                ) : (
                  <div>
                    <AssetActionFormComponent
                      formRef={formRef}
                      validation={validation}
                      initialValues={initialValues}
                      formConfig={formConfig}
                      moduleName={"Rain Profile"}
                      actionName={"Edit-Rain Profile"}
                    />
                    <div>
                      <HasPermission
                        moduleName="Rain Profile"
                        actionName="Edit-Rain Profile"
                        isRoute={false}
                      >
                        <B2Button onClick={() => onSubmit()}>Save</B2Button>
                      </HasPermission>
                    </div>
                  </div>
                )}
              </B2Card.Body>
            </B2Card>
          </div>
        </div>

        {/* modals */}
        {isOTPModalOpen && (
          <ModalComponent
            showModal={isOTPModalOpen}
            handleClose={handleCloseOtpModal}
            actionConfig={mfaActionConfig}
            headerTitle={"Multi Factor Authentication"}
            isViewMode={false}
          >
            <MfaComponent />
          </ModalComponent>
        )}
      </div>
    </>
  );
};

export default RainProfileComponent;
